let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dtu8K")).then(() => parcelRequire('cHUWY'));